import React, { useRef } from 'react';
import IdleTimer from 'react-idle-timer';

const IdleController = props => {
  const timeout = 1000 * 60 * 20; // 20 mins

  const ref = useRef();

  const handleOnIdle = event => {
    props.handleLogout();
  };

  return (
    <IdleTimer
      ref={ref}
      timeout={timeout}
      // onActive={handleOnActive}
      onIdle={handleOnIdle}
      // onAction={handleOnAction}
      debounce={250}
    />
  );
};

export default IdleController;
